import throttle from 'lodash/throttle';

export default class Animation {
  constructor({el} = {}) {
    this.el = document.querySelectorAll(el);

    this.animate = this.animate.bind(this);

    this.init();
  }

  init() {
    if (!this.el) return;
    this.animate();
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('scroll', throttle(this.animate, 100));
  }

  animate() {
    const denominator = 1.5;

    this.el.forEach(el => {
      if (el.getBoundingClientRect().top <= window.innerHeight / denominator) {
        el.classList.add('is-visible');
      }
    });
  }
}